// Relative lease countdown for RunDetail. `now` is injectable so it's
// deterministic in tests; the component calls it with the default (Date.now()).
export function formatLeaseCountdown(
  leaseExpiresAt: string | null,
  nowMs: number = Date.now(),
): string {
  if (!leaseExpiresAt) return "";
  const expiresMs = new Date(leaseExpiresAt).getTime();
  if (!Number.isFinite(expiresMs)) return "";
  const diffMs = expiresMs - nowMs;
  if (diffMs <= 0) return "lease expired";
  const secs = Math.round(diffMs / 1000);
  if (secs < 60) return `expires in ${secs}s`;
  return `expires in ${Math.round(secs / 60)}m`;
}
